import { Component, Input, forwardRef, Inject } from '@angular/core';
import { UIRouter }         from '@uirouter/core';
import { TranslateService } from '@ngx-translate/core';

import { CompanyService }         from '../companies/company.service';
import { LaborProductModel }      from '../products/models/labor-product';
import { MessagesService }        from '../messages/messages.service';
import { PartstechService }       from './partstech.service';
import { PartstechSettingsModel } from './models/partstech.settings';

@Component({
  selector   : 'wor-partstech-settings',
  template: require('./partstech.settings.component.html')
})
export class PartstechSettingsComponent {
  @Input() integrations: PartstechSettingsModel;

  constructor (
    @Inject(forwardRef(() => CompanyService))
    public companyService    : CompanyService,
    @Inject(forwardRef(() => MessagesService)) private messagesService  : MessagesService,
    @Inject(forwardRef(() => PartstechService)) private partstechService : PartstechService,
    private router           : UIRouter,
    private translateService : TranslateService
  ) {}

  activate () : void {
    this.partstechService.activate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: 'Partstech'
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  deactivate () : void {
    this.partstechService.deactivate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', {
        name: 'Partstech'
      }), 'success');

      this.router.stateService.reload();
    }).catch(err => {
      this.messagesService.error(err);
    });
  }

  onLaborProductSelect ( product : LaborProductModel, key : string ) : void {
    this.integrations[ `partstech_${ key }_product_id` ]   = product.id;
    this.integrations[ `partstech_${ key }_product_name` ] = product.item_code;
  }

  save () : void {
    this.partstechService.save(this.integrations)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');

      this.router.stateService.reload();
    }).catch(err => {
      this.messagesService.error(err);
    });
  }
}